import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="var(--svg-color, currentColor)"
			d="M8.5 3.755a.5.5 0 1 0-1 0V7.5H3.753a.5.5 0 1 0 0 1h3.745v3.746a.5.5 0 1 0 1 0V8.5h3.746a.5.5 0 0 0 0-1H8.499z"
		/>
	</svg>
);

export { SvgComponent as PlusIcon };
